﻿import { FC } from 'react';
import { ROUTES } from '../config/routes';
import { MainLayout } from '../components/layouts/MainLayout';
import {
  HomePage,
  AboutPage,
  CareerCoachingPage,
  BusinessSolutionsPage,
  ContactPage,
  DigitalProductsPage,
  ProductDetailPage,
  FreeInterviewGuidePage,
  ThankYouPage,
  CheckoutPage,
  PaymentSuccessPage,
  PaymentFailedPage,
  DownloadPage,
  PrivacyPolicyPage,
  TermsPage,
  RefundPolicyPage,
  NotFoundPage
} from '../pages';

export interface AppRouterProps {
  currentPath: string;
  onNavigate: (path: string) => void;
}

export const AppRouter: FC<AppRouterProps> = ({ currentPath, onNavigate }) => {
  // Normalize path without query string for routing
  const normalizedPath = currentPath.split('?')[0];

  const renderRoute = () => {
    // 1. Static Exact Routes
    switch (normalizedPath) {
      case ROUTES.HOME:
        return <HomePage onNavigate={onNavigate} />;
      case ROUTES.ABOUT:
        return <AboutPage onNavigate={onNavigate} />;
      case ROUTES.CAREER_COACHING:
        return <CareerCoachingPage onNavigate={onNavigate} />;
      case ROUTES.BUSINESS_SOLUTIONS:
        return <BusinessSolutionsPage onNavigate={onNavigate} />;
      case ROUTES.CONTACT:
        return <ContactPage onNavigate={onNavigate} />;
      case ROUTES.DIGITAL_PRODUCTS:
        return <DigitalProductsPage onNavigate={onNavigate} />;
      case ROUTES.FREE_INTERVIEW_GUIDE:
        return <FreeInterviewGuidePage onNavigate={onNavigate} />;
      case ROUTES.THANK_YOU:
        return <ThankYouPage onNavigate={onNavigate} />;
      case ROUTES.CHECKOUT:
        return <CheckoutPage onNavigate={onNavigate} />;
      case ROUTES.PAYMENT_SUCCESS:
        return <PaymentSuccessPage onNavigate={onNavigate} />;
      case ROUTES.PAYMENT_FAILED:
        return <PaymentFailedPage onNavigate={onNavigate} />;
      case ROUTES.DOWNLOAD:
        return <DownloadPage onNavigate={onNavigate} />;
      case ROUTES.PRIVACY_POLICY:
        return <PrivacyPolicyPage onNavigate={onNavigate} />;
      case ROUTES.TERMS:
        return <TermsPage onNavigate={onNavigate} />;
      case ROUTES.REFUND_POLICY:
        return <RefundPolicyPage onNavigate={onNavigate} />;
    }

    // 2. Dynamic Product Detail Routes: /digital-products/:slug
    if (normalizedPath.startsWith('/digital-products/')) {
      const slug = normalizedPath.replace('/digital-products/', '');
      return <ProductDetailPage slug={slug} onNavigate={onNavigate} />;
    }

    // 3. Fallback: 404 Not Found
    return <NotFoundPage onNavigate={onNavigate} />;
  };

  return (
    <MainLayout currentPath={normalizedPath} onNavigate={onNavigate}>
      {renderRoute()}
    </MainLayout>
  );
};

